import {Component, Input, OnInit} from '@angular/core';
import {WdrVideoTextBericht} from '../../../../../../../model/vorhersagen/wdr-wetterbericht';

@Component({
  selector: 'app-wdr-videotext-bericht',
  templateUrl: './wdr-videotext-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class WdrVideotextBerichtComponent {

  @Input() videotextVorhersageBericht: WdrVideoTextBericht;


}
